export default "__VITE_ASSET__eaeb1711__"